module.exports = __webpack_public_path__ + "img/swiper_04.c4b799e7.jpg";